import React, { useEffect, useState } from 'react';
import DiscussForm from '../../components/DiscussForm';
import videoDark from '../../images/Coming Soon (Black).mp4';
import videoLight from '../../images/Coming Soon (Black with White BG).mp4';

function Pune() {
    const [theme, setTheme] = useState('light');

    useEffect(() => {
        window.scrollTo(0, 0);

        const getTheme = () =>
            document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';

        setTheme(getTheme());

        const observer = new MutationObserver(() => {
            setTheme(getTheme());
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme'],
        });

        return () => observer.disconnect();
    }, []);

    const videoSrc = theme === 'dark' ? videoDark : videoLight;

    return (
        <div className='location-main'>
            {/* Hero Section */}
            <div className='about-hero hyd-hero'>
                <div className='about-hero-inner d-flex justify-content-center align-items-center'>
                    <div>
                        <h1 className='syne-title'>Pune<span className='text-rose'>.</span></h1>
                        <p className='text-center'>
                            Home / Locations / <span className='text-rose'>Pune</span>
                        </p>
                    </div>
                </div>
            </div>

            {/* Video Section */}
            <div className='video-section'>
                <video
                    key={videoSrc}
                    src={videoSrc}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className='w-100 theme-video'
                />
            </div>

            {/* Discuss Form */}
            <DiscussForm />
        </div>
    );
}

export default Pune;


// /////////////////
// import React, { useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import DiscussForm from '../../components/DiscussForm';
// import projects from '../../data/ProjectsData';
// import { FaLongArrowAltRight } from "react-icons/fa";
// import '../../Location.css';
// import '../../Home.css';

// function Pune() {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const filteredProjects = projects.filter(
//     (project) => project.location?.toLowerCase() === 'pune'
//   );

//   return (
//     <div className='location-main'>
//       {/* Pune Hero */}
//       <div className='about-hero hyd-hero'>
//         <div className='about-hero-inner d-flex justify-content-center align-items-center'>
//           <div>
//             <h1 className='syne-title'>Pune<span className='text-rose'>.</span></h1>
//             <p className='text-center'>
//               <Link to="/" className="text-dark text-decoration-none">Home</Link> /{' '}
//               <Link to="/projects" className="text-dark text-decoration-none">Locations</Link> /{' '}
//               <span className='text-rose'>Pune</span>
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Pune Projects */}
//       <div className='container-fluid py-4'>
//         <div className='container py-4'>
//           <div className="row">
//             {filteredProjects.length > 0 ? (
//               filteredProjects.map((project) => (
//                 <div className="col-lg-4 col-md-6 my-3" key={project.id}>
//                   <div className="home-land-card h-100 shadow-sm">
//                     <img src={project.image} className="img-fluid home-land-card-img" alt={project.title} />
//                     <div className="home-land-card-content p-3 text-center bg-white">
//                       <h6 className="fw-bold">{project.title}</h6>
//                       <p className="mb-1">{project.location}</p>
//                       <div className="home-about-btn text-center">
//                         <Link to={`/projects/${project.id}`} className="text-rose">
//                           <FaLongArrowAltRight /> Know More
//                         </Link>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <p className='text-center text-secondary'>No projects available in Pune at the moment.</p>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Discuss Form */}
//       <DiscussForm />
//     </div>
//   );
// }

// export default Pune;

// ////////////////